/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     优惠券模块api
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function couponCreateApi(data) {
  return request({
    url: `${jsApiHost}/ei/couponscheme/create`,
    method: "post",
    data
  })
}

export function couponListApi(params) {
  return request({
    url: `${jsApiHost}/ei/couponscheme/list`,
    method: "get",
    params
  })
}

export function couponEnableApi(data) {
  return request({
    url: `${jsApiHost}/ei/couponscheme/enable/update`,
    method: "post",
    data
  })
}

export function couponAbolishApi(data) {
  return request({
    url: `${jsApiHost}/ei/couponscheme/abolish`,
    method: "post",
    data
  })
}

export function couponDeleteApi(data) {
  return request({
    url: `${jsApiHost}/ei/couponscheme/delete`,
    method: "post",
    data
  })
}

export function couponGetApi(params) {
  return request({
    url: `${jsApiHost}/ei/couponscheme/get`,
    method: "get",
    params
  })
}

export function couponeiReceiveListApi(params) {
  return request({
    url: `${jsApiHost}/ei/couponscheme/receive/list`,
    method: "get",
    params
  })
}
